import f3tch from 'f3tch';

import API_URL from '../../constants/url.constant.api';
import profile from '../../profiles/json.profile.api';

const listBrandsApi = (query = {}) =>
  f3tch('/brands')
    .profile(profile({url: API_URL()}))
    .query(query)
    .get();

export default listBrandsApi;
